.section {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding-bottom: 20px;
  padding-top: 10px;

  &.disabled {
    opacity: 0.5;
    pointer-events: none;

    .headerRow {
      pointer-events: auto;
    }
  }
}

.headerRow {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.headerLeft {
  display: flex;
  align-items: center;
  gap: 8px;
}

.addonChip {
  display: flex;
  align-items: center;
  height: 20px;
  padding: 4px 8px;
  font-family: Sohne;
  font-size: 11px;
  font-weight: 500;
  letter-spacing: 0.44px;
  background: linear-gradient(180deg, #9500ff 0%, #6a00ff 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  position: relative;

  &::before {
    content: '';
    position: absolute;
    inset: 0;
    border-radius: 16px;
    background: linear-gradient(0deg, rgba(106, 0, 255, 0.15) 0%, rgba(149, 0, 255, 0.15) 100%), #f3f5f6;
    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.1);
    z-index: -1;
  }
}

.warningBanner {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 15px;
  border-radius: 10px;
  background: rgba(252, 214, 0, 0.1);
}

.description {
  margin-bottom: 8px;
}

.ineligibleMessage {
  display: block;
  margin-top: 4px;
  font-style: italic;
}

.options {
  margin-top: 24px;
}

$mobile-breakpoint: 768px;

.twoColumns {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 32px;

  @media (max-width: $mobile-breakpoint) {
    grid-template-columns: 1fr;
  }
}

.column {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.subsectionTitle {
  font-weight: 600;
}

.helpLine {
  display: flex;
  align-items: center;
  gap: 5px;
  margin-top: 25px;
}

.link {
  color: #0099f7;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
}

.linkButton {
  background: none;
  border: none;
  padding: 0;
  color: #0099f7;
  cursor: pointer;
  font: inherit;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
}
